module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABwAAAAcBAMAAACAI8KnAAAAJ1BMVEVHcEyJiYmIiIiIiIiIiIgqKiqLi4uIiIiJiYmIiIiJiYmIiIiIiIhs2HGCAAAADHRSTlMAPunD+AEg11eIDaJNOgIUAAAApUlEQVQY02NgAILAySpOlqIMUMBRcwYIjjdAeGw2Z8DgcAKYK3QGChRBPEYfGPeIAJCbdAYO1IBcGwT3MNDYM0iggSEcRAlClZQyyIAoBkaw1WcOMswBc1kjdED0SYhJDKyhK33AZoFFGRhYGbKB9CEGHwgXCICmHEHn6sC4EMU2UC7UKDSL0JyB5kiIF3xgXkDzILr30QIHLegYwlADFi3YkSMFADmByZJxKxOQAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/old_age_education/lesson-icon2-played.png
// module id = C8iC
// module chunks = 1